import { Extension } from '@tiptap/core';

import {
  createMedicationHighlightsPlugin,
  medicationHighlightsPluginKey,
} from './create-plugin';

export { medicationHighlightsPluginKey };

export const MedicationHighlights = Extension.create({
  name: 'medicationHighlights',

  addProseMirrorPlugins() {
    return [createMedicationHighlightsPlugin()];
  },
});
